const graphSortOptions = {
  az: 'A-Z',
  za: 'Z-A',
  asc: 'ASC',
  desc: 'DESC',
};

export default graphSortOptions;
